// File: frontend/src/components/molecules/WModalGeneric.js

import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const WModalGeneric = ({
  show,
  onHide,
  onSubmit,
  title = "Conferma Operazione",
  body,
  confirmText = "Conferma",
  cancelText = "Annulla"
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {body}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center align-items-center">
        <Button variant="primary" onClick={onSubmit}>
          {confirmText}
        </Button>
        <Button variant="danger" onClick={() => onHide(false)}>
          {cancelText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WModalGeneric;